import { render, staticRenderFns } from "./Workflow.vue?vue&type=template&id=39d2ae5c&scoped=true"
import script from "./Workflow.vue?vue&type=script&lang=ts"
export * from "./Workflow.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39d2ae5c",
  null
  
)

export default component.exports